export default __webpack_public_path__ + "static/media/bg.5b9089cb.jpg";